import {hotelStates} from './hotels-routes';
import hotelEvents from './config/hotel-events';

export default function HotelResultsController(
    $scope,
    $state,
    $stateParams,
    hotelSearchResults,
    hotelsFactory
) {
    'ngInject';

    const vm = this;
    const filters = {};
    Object.assign(vm, {
        $onInit,
        increaseSearchRadius,
    });

    function $onInit() {
        vm.hotelSearchResults = hotelSearchResults;
        vm.filtersAvailable = !_.isEmpty(hotelSearchResults.Filters);

        subscribe();
    }

    function subscribe() {
        $scope.$on(hotelEvents.HOTELS_APPLY_FILTERS, (event, newValue) => Object.assign(filters, newValue));
    }

    function increaseSearchRadius() {
        const {HotelSorting} = hotelsFactory.getFormData();
        Object.assign($stateParams, filters, {Radius: hotelSearchResults.ExtendedRadius}, {HotelSorting});
        $state.go(hotelStates.HOTEL_RESULTS, $stateParams, {reload: true});
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/hotels/hotel-results-controller.js